import React, { FC, memo } from "react";

import { Container, ContainerAlias, ContainerValue, TwoColumnContainerWrapper } from "./styled";
import { ContainerProps } from "../types";

export const TwoColumnsInnerContainer: FC<ContainerProps> = memo(({ renderElement }) => {
  return (
    <>
      <TwoColumnContainerWrapper>
        <Container>
          <ContainerAlias>{renderElement({ id: "firstAlias" })}</ContainerAlias>
          <ContainerValue big>{renderElement({ id: "firstValue" })}</ContainerValue>
        </Container>
        <Container>
          <ContainerAlias>{renderElement({ id: "secondAlias" })}</ContainerAlias>
          <ContainerValue big>{renderElement({ id: "secondValue" })}</ContainerValue>
        </Container>
      </TwoColumnContainerWrapper>
      {renderElement({ id: "thirdContainer" })}
    </>
  );
});
